module.exports = __webpack_public_path__ + "img/1.a1523b65.svg";